import { DialogueData } from '../../atoms/dialogue';

const dialogue_car_05: DialogueData = {
	name: 'Dispatch',
	messages: { 
		
		// start message         
		'dialogue_car_05_00':{
			speakingCharacter: 0,
			followupMessage: 'dialogue_car_05_01'
		},
		'dialogue_car_05_01':{
			speakingCharacter: 0,
		},
	}
};

export default dialogue_car_05;